/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AdministrationScheduleFractionalDoseAliases {
  ADM_SCHEDULE_FRACTIONAL_DOSE_BUTTON = 'adm-schedule-fractional-dose-button',
  ADM_SCHEDULE_FRACTIONAL_DOSE_CODE_FIELD = 'adm-schedule-fractional-dose-code-field',
  ADM_SCHEDULE_FRACTIONAL_DOSE_CODE_TEXT = 'adm-schedule-fractional-dose-code-text',
  ADM_SCHEDULE_FRACTIONAL_DOSE_CONTAINER_PANEL_BUTTON = 'adm-schedule-fractional-dose-container-panel-button',
  ADM_SCHEDULE_FRACTIONAL_DOSE_FIELD = 'adm-schedule-fractional-dose-field',
  ADM_SCHEDULE_FRACTIONAL_DOSE_FORM = 'adm-schedule-fractional-dose-form',
  ADM_SCHEDULE_FRACTIONAL_DOSE_INPUT = 'adm-schedule-fractional-dose-input',
  ADM_SCHEDULE_FRACTIONAL_DOSE_LAYOUT = 'adm-schedule-fractional-dose-layout',
  ADM_SCHEDULE_FRACTIONAL_DOSE_NAME_FIELD = 'adm-schedule-fractional-dose-name-field',
  ADM_SCHEDULE_FRACTIONAL_DOSE_NAME_TEXT = 'adm-schedule-fractional-dose-name-text',
  ADM_SCHEDULE_FRACTIONAL_DOSE_PADDING_BUTTON = 'adm-schedule-fractional-dose-padding-button',
  ADM_SCHEDULE_FRACTIONAL_DOSE_PANEL = 'adm-schedule-fractional-dose-panel',
  ADM_SCHEDULE_FRACTIONAL_DOSE_PANEL_BUTTON = 'adm-schedule-fractional-dose-panel-button',
  ADM_SCHEDULE_FRACTIONAL_DOSE_REMAINING_FIELD = 'adm-schedule-fractional-dose-remaining-field',
  ADM_SCHEDULE_FRACTIONAL_DOSE_REMAINING_TEXT = 'adm-schedule-fractional-dose-remaining-text',
  ADM_SCHEDULE_FRACTIONAL_GLOBAL_ACTIONS = 'adm-schedule-fractional-global-actions',
  ADM_SCHEDULE_FRACTIONAL_UNIT_MEASURE = 'adm-schedule-fractional-unit-measure',
  ADM_SCHEDULE_FRACTIONAL_UNIT_MEASURE_TEXT = 'adm-schedule-fractional-unit-measure-text',
}
export { AdministrationScheduleFractionalDoseAliases };
